<template>
    <div class="electrictiy-bill-calculator__accordion">
        <div class="is-collapsed electrictiy-bill-calculator__accordion-button" ref="accordionElement">
            <div class="electrictiy-bill-calculator__accordion-button-slant">
                <div class="electrictiy-bill-calculator__accordion-button-slant-content">
                    <div class="electrictiy-bill-calculator__accordion-button-status-and-title">
                        <span class="electrictiy-bill-calculator__accordion-button-status" :class="valueIsSet && !isOpen ? 'electrictiy-bill-calculator__accordion-button-status--checked' :''"  aria-hidden="true">                            
                            <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
                            <g transform="translate(-228 -504)">
                                <circle cx="15.5" cy="15.5" r="15.5" transform="translate(228 504)" fill="#80954e"/>
                                <path d="M3410.667,9259.4l5.683,6.534,10.849-12.4" transform="translate(-3175.858 -8740.007)" fill="none" stroke="#fff" stroke-width="2"/>
                            </g>
                            </svg>
                        </span>                
                        <div class="electrictiy-bill-calculator__accordion-button-title">
                            {{title}}
                        </div>
                    </div>
                    <div class="electrictiy-bill-calculator__accordion-button-value-and-change" v-if="!isOpen">
                        <div class="electrictiy-bill-calculator__accordion-button-value" v-if="selectedValue && !isOpen && valueIsSet">
                            {{selectedValue}}
                        </div>
                        <button class="electrictiy-bill-calculator__accordion-button-change" v-if="!isOpen && valueIsSet" :aria-controls="'step-'+stepNumber" @click="onFormStepButtonClick" :aria-expanded="isOpen">
                            Ändra
                        </button>
                    </div>
                </div>
            </div>
            <button type="button" class="electrictiy-bill-calculator__accordion-button-icon" :aria-controls="'step-'+stepNumber" @click="onFormStepButtonClick" :aria-expanded="isOpen">
                <span :class="[isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down']"></span><span class="is-visuallyhidden">Öppna/stäng</span>
            </button>
        </div>
        <Transition :name="transitionName">
		<div :id="'step-'+stepNumber" class="electrictiy-bill-calculator__accordion-body" :aria-hidden="!isOpen" v-if="isOpen" ref="accordionBodyElement">
            <div class="electrictiy-bill-calculator__accordion-body-inner-wrapper">
                <form @submit.prevent="submitForm">
                    <slot></slot>            
                    
                    <div class="electrictiy-bill-calculator__accordion-footer">
                        <button type="submit" v-if="showNextStep" class="electrictiy-bill-calculator__accordion-footer-next">{{appSettings.NextStepButtonText}}</button>
                        <button type="submit" v-else class="electrictiy-bill-calculator__accordion-footer-next">{{ calculateButtonText }}</button>
                    </div>
                </form>
            </div>
		</div>
        </Transition>
	</div>
</template>


<script setup>
    import util from '../util';
    import { computed, onMounted, onActivated, ref, watch, nextTick } from 'vue'
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    import {CustomerTypeEnum} from "./../Enums";

    const store = useWizardStore()
    const { appSettings, currentStep, numberOfSteps, customerType, showResults } = storeToRefs(store); 
    
    const props = defineProps({
        title: { type: String, required: true },
        stepNumber: { type: Number, required: true },
    });
    const emit = defineEmits(['toggleBody'])

    const accordionElement = ref();
    const accordionBodyElement = ref();

    const isOpen = computed(() => {
        return currentStep.value === props.stepNumber;
    })
     
    const showNextStep = computed(() => {
        if(customerType.value === CustomerTypeEnum.APPARTMENT) {
            return props.stepNumber < 2;
        }        
        return props.stepNumber < numberOfSteps.value;
    })

    const transitionName = computed(() => {
        if(currentStep.value <= 4) {
            return 'slide';
        }
        return 'slide--no-delay';
    })

    const selectedValue = computed(() => {
        switch(props.stepNumber) {
            case 1:
                return store.selectedCustomerTypeName;
            case 2:
                return store.selectedFuseName;
            case 3:
                return util.getFormatedValue(store.yearlyConsumption, 0, 'kWh');
            default:
                return null;
        }
    })

    const valueIsSet = computed(() => {
        switch(props.stepNumber) {
            case 1:
                return store.customerType !== null;
            case 2:
                return store.fuseType !== null;
            case 3:
                return store.monthlyConsumption !== null;
            case 4:
                return store.powerPeak !== null;
        }
    })

    const calculateButtonText = computed(() => {
        if(showResults.value) {
            return appSettings.value.UpdateButtonText;
        } else {
            return appSettings.value.CalculateButtonText;
        }
    })

    const onFormStepButtonClick = () => {
        util.scrollIntoViewIfNeeded(accordionElement.value);
        if(isOpen.value) {
            store.gotoWizardStep(null);
        } else {
            store.gotoWizardStep(props.stepNumber);
        }
    }

    const submitForm = () => {
        util.scrollIntoViewIfNeeded(accordionElement.value);
        if(showNextStep.value) {
            store.gotoNextWizardStep();
        } else {
            store.calculateAndShowResult();
        }
    }
    
    watch(isOpen, (newVal, oldVal) => {
        emit('toggleBody', newVal);
    })
</script>

<style scoped>

.slide-enter-active {
    transition: grid-template-rows 400ms ease;
    transition-delay: 200ms;
}

.slide-leave-active {
    transition: grid-template-rows 200ms ease;
    transition-delay: 0ms;
}

.slide-enter-to,
.slide-leave-from {
    grid-template-rows: 1fr;
}
.slide-enter-from,
.slide-leave-to {
    grid-template-rows: 0fr;
}
</style>
